export const AUCTION_DEFAULT_ORDER_ID = 'END_TIME_ASC';
